"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_1 = require("../../token");
const request = async (config) => {
    // if (TARGET === 'web') {
    //     const crossStorage = window.__sensecommon.cs
    //     if (!crossStorage.isReady) {
    //         throw Error('crosssStorage is not ready yet, make sure to use senseFetch and senseAxios after crossStorage ready')
    //     }
    // }
    const accesstoken = await (0, token_1.getToken)('accessToken');
    config.headers.set('Authorization', `Bearer ${accesstoken ?? ''}`);
    return config;
};
exports.default = request;
